import React from 'react';
import PropTypes from 'prop-types';
import _lowerCase from 'lodash/lowerCase';

import { TEXT_ALIGNMENT_OPTIONS } from '../../../../constants/Cards';
import './TextAlignmentField.less';

export default function TextAlignmentField({ input: { value, onChange } }) {
  return (
    <div className="text-alignment-field">
      {TEXT_ALIGNMENT_OPTIONS.map(alignmentOption => (
        <div
          key={alignmentOption}
          className={`text-alignment-option${
            alignmentOption === value ? ' text-alignment-option--active' : ''
          }`}
          onClick={() => onChange(alignmentOption)}
        >
          <i className={`zolaicon zolaicon-text-align-${_lowerCase(alignmentOption)}`} />
        </div>
      ))}
    </div>
  );
}

TextAlignmentField.propTypes = {
  input: PropTypes.shape({}),
};



// WEBPACK FOOTER //
// ./src/cards/components/Customization/ElementStyleEditor/TextAlignmentField/TextAlignmentField.jsx